import { CommissionStatuses } from 'constants/commissionStatuses';
import { Role } from 'constants/roles';

import { useCallback } from 'react';

import { usePermissions } from 'hooks/usePermissions';
import { Commission } from 'types/embedded/commission';

export function useCommissionsEditable() {
  const { roles } = usePermissions();

  const checkCommissionsEditable = useCallback(
    (record?: Commission) => {
      const hasRole = [Role.Admin, Role.Tech, Role.Payment, Role.Finance, Role.FinanceLead].some(
        (role) => roles.includes(role),
      );

      return (
        hasRole &&
        [CommissionStatuses.Created, CommissionStatuses.Rejected].some(
          (status) => record?.status?.value === status,
        )
      );
    },
    [roles],
  );

  return { checkCommissionsEditable };
}
